import { useState } from 'react';

export function useLocalStorage(key: string, defaultValue: string): [string, (value: string) => void] {
  const [value, setValue] = useState<string>(() => {
    try {
      const item = window.localStorage.getItem(key);
      if (!item) {
        window.localStorage.setItem(key, defaultValue);
        setValue(defaultValue);
        return defaultValue;
      }

      return item;
    } catch (error) {
      return defaultValue;
    }
  });

  const setStoredValue = (newValue: string) => {
    try {
      setValue(newValue);
      window.localStorage.setItem(key, newValue);
    } catch (error) {
      console.error(`Error saving to localStorage:`, error);
    }
  };

  return [value, setStoredValue];
}